import { render, staticRenderFns } from "./PharmacyRegistrationForm.vue?vue&type=template&id=5ee385f3&scoped=true"
import script from "./PharmacyRegistrationForm.vue?vue&type=script&lang=js"
export * from "./PharmacyRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee385f3",
  null
  
)

export default component.exports